import { useState, useEffect } from "react";

const SectionProgress = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);

  const sections = [
    { id: "inicio", label: "Início" },
    { id: "servicos", label: "Serviços" },
    { id: "depoimentos", label: "Depoimentos" },
    { id: "sobre", label: "Sobre" },
    { id: "como-funciona", label: "Processo" },
    { id: "contato", label: "Contato" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      // Calculate overall scroll progress
      const winScroll =
        document.body?.scrollTop || document.documentElement?.scrollTop;
      const height =
        document.documentElement?.scrollHeight -
        document.documentElement?.clientHeight;
      const scrolled = (winScroll / height) * 100;
      setScrollProgress(scrolled);

      // Update active section
      const currentSection = sections?.findIndex((section) => {
        const element = document.getElementById(section?.id);
        if (element) {
          const rect = element?.getBoundingClientRect();
          return rect?.top <= 100 && rect?.bottom >= 100;
        }
        return false;
      });

      if (currentSection !== -1) {
        setActiveSection(currentSection);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSectionClick = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      {/* Desktop - Vertical Progress Indicator */}
      <div className="hidden lg:block fixed right-8 top-1/2 transform -translate-y-1/2 z-40">
        <div className="flex flex-col space-y-4">
          {sections?.map((section, index) => (
            <button
              key={section?.id}
              onClick={() => handleSectionClick(section?.id)}
              className={`group relative w-3 h-3 rounded-full transition-all duration-300 ${
                index === activeSection
                  ? "bg-primary scale-125"
                  : "bg-border hover:bg-primary/50"
              }`}
              title={section?.label}
            >
              {/* Tooltip */}
              <div className="absolute right-6 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                <div className="bg-gray-900 text-white text-sm px-3 py-1 rounded-md whitespace-nowrap">
                  {section?.label}
                </div>
                <div className="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-gray-900"></div>
              </div>
            </button>
          ))}
        </div>
      </div>
      {/* Mobile - Horizontal Progress Bar */}
      <div className="lg:hidden fixed top-16 left-0 right-0 z-40 bg-background/95 backdrop-blur border-b">
        <div className="h-1 bg-border">
          <div
            className="h-full bg-primary transition-all duration-300 ease-out"
            style={{ width: `${scrollProgress}%` }}
          />
        </div>
        <div className="px-4 py-2">
          <div className="flex justify-between text-xs text-muted-foreground">
            {sections?.map((section, index) => (
              <button
                key={section?.id}
                onClick={() => handleSectionClick(section?.id)}
                className={`transition-colors duration-200 ${
                  index === activeSection
                    ? "text-primary font-medium"
                    : "hover:text-primary"
                }`}
              >
                {section?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionProgress;
